import { useMutation as useRQMutation } from 'react-query';

export const useMutation = useRQMutation;
